export class AppConfig {
  /*LOCAL*/
  /*public static API_URL = 'http://localhost:8000/api/v1/';*/

 /* public static API_URL = 'https://wowadmin.messoft.net/api/v1/';*/
  /*MESSOFT*/

  public static API_URL = 'http://admin.wow24.mx/';
  /*CLIENTE*/

  public static VERSION = '1.0-prod';
}




// WEBPACK FOOTER //
// ./src/app/app.config.ts